import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

const Tabs = ({ tabs, className }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className={twMerge('mt-4 grid gap-2 md:gap-2', className)}>
      <div className="flex text-sm font-base md:text-base border-b border-gray-200 w-full justify-between">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`px-4 w-full py-2 cursor-pointer ${
              activeTab === index ? 'border-b-2 border-contrast2 text-contrast2' : 'hover:contrast2'
            }`}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>
        {tabs.map((tab, index) => (
          <div key={index} className={activeTab === index ? 'block' : 'hidden'}>
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
